// tRPC Client — CMS Cabinet Medical Școlar
// Folosit în componente React client-side cu TanStack Query

'use client'

import { createTRPCReact } from '@trpc/react-query'
import type { AppRouter } from '@/server/routers'

export const trpc = createTRPCReact<AppRouter>()
